import React from 'react';

export function SearchHistoryItem({ title, text, icon, onClick }) {

    return (
        <div className="bg-white relative py-2 pr-2 pl-12 border-b border-gray-300 cursor-pointer transition-all" onClick={onClick}>
            <div className="absolute top-1 left-2">
                <span className={`text-lg icon icon-${icon}`} />
            </div>
            <div className="text-gray-900 font-semibold">{title}</div>
            <div className="text-gray-500 text-sm">{text}</div>
        </div>
    );
}
